import React from "react";
import NewBannerImage from "../assests/images/newBanner.svg"; // Replace with updated path
import GooglePlayQRCode from "../assests/images/googleStore.svg";
import AppStoreQRCode from "../assests/images/appStore.svg";
const CreativitySection = () => {
  return (
    <section
      id="home"
      className="bg-[#30D5C8] relative pt-[108px] pb-20 lg:pt-[108px] lg:pb-16 overflow-hidden shadow-lg"
    >
      <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 items-center gap-12">
        <div className="text-center md:text-left">
          <h2 className="text-2xl md:text-2xl custom:text-4xl max-custom:text-2xl sm:text-2xl font-bold text-white mb-6 flex flex-row items-center justify-center md:justify-start mt-4 lg:mt-0">
            Your Art. Your People. Your Platform.
          </h2>
          <p className="text-base md:text-xl lg:text-2xl text-gray-600 mb-10 w-full custom:w-[100%] text-center md:text-left leading-relaxed">
            The all-in-one app for creatives to monetize, build community, and
            grow.
          </p>

          <div className="flex [@media(min-width:768px)]:justify-start sm:justify-center md:justify-center [@media(max-width:640px)]:justify-center space-x-6">
            <a href="https://play.google.com/store/apps/details?id=com.pepli.app" target="_blank" rel="noopener noreferrer">
              <img
                src={GooglePlayQRCode}
                alt="Google Play Store QR Code"
                className="w-44 h-44 object-contain cursor-pointer"
              />
            </a>
            <a href="https://apps.apple.com/us/app/pepli/id6464536675" target="_blank" rel="noopener noreferrer">
              <img
                src={AppStoreQRCode}
                alt="App Store QR Code"
                className="w-44 h-44 object-contain cursor-pointer"
              />
            </a>
          </div>
        </div>

        <div className="flex justify-center md:justify-end">
          <img
            src={NewBannerImage}
            alt="Creativity Visual"
            className="w-full max-w-[680px] h-auto object-contain lg:mt-10 mt-4"
          />
        </div>
      </div>
    </section>
  );
};

export default CreativitySection;
